import columnBlockMeta from './block.json';
import columnIcon from './icon';
import { defaultAttributes } from './attributes';
import { attributeFlexSettings } from '@components/flex-settings/attributes';
import { attributeBackgroundTypes } from '@components/background-types/attributes';
import attributeVisibility from '@components/visibility/attributes.json';
import attributeClassDropDown from '@components/class-dropdown/attributes.json';
import { getBlockLabelByName } from '@helpers/utils';
import edit from './edit';
import save from './save';
import './style.scss';

const { registerBlockType } = wp.blocks;
const { name, ...settings } = columnBlockMeta;

const attributes = {
  ...defaultAttributes,
  ...attributeFlexSettings,
  ...attributeVisibility,
  ...attributeClassDropDown,
  ...attributeBackgroundTypes,
};

registerBlockType(name, {
  ...settings,
  attributes,
  icon: columnIcon,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
